import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { getCategories } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CategoriesCRUD from "./CategoriesCRUD";


const CategoriesScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const [selected, setSelected] = useState(null)
  
  const getInfo = async () => {
    setLoading(true);
    let result = await getCategories();
    setData(result);
    setLoading(false);
  };

  const colums = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdCategoria',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Código',
      headerEn: 'Code',
      field: 'CodigoCategoria',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'Xsmall',
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'Categoria',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'Xlarge',
    },
    {
      header: 'Tipo de Cluenta',
      headerEn: 'Acount Type',
      field: 'Type',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'medium',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'medium',
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdType",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdType){
              setSelected(rowData)
              setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const table = {
    Columns: colums,
    Data: data,
    showModal: () => {}
  }

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "categoria", config.language));
  }, []);
  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "categoria", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            <Button
              icon="pi pi-plus"
              tooltip="Nuevo"
              onClick={(e) => {
                setShowDialog(true)
                setSelected(null)
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />
            <div style={{ height: '87vh' }}>
              <AgGrid table={table} />
            </div>
          </div>
        }
      />

      {showDialog && (
        <CategoriesCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}

    </div>
  );
};

export default CategoriesScreen;
